<template>
  <div id="warningmsg" class="warningmsg-wrapper dash-item col-md-4">
    <div class="warningmsg-header-box dash-bg-color-skin-light-10">
      <div class="header-center">
        <div class="rec"></div>
        {{ app.home[app.nowLang].warningmsg }}
      </div>
    </div>

    <div class="warningmsg-content-box">
      <div v-for="(textwarningmsg, index) in warningmsg.rows"
            class="warningmsg-content" :class ="{'row-even' : index % 2 == 0}">
        {{ textwarningmsg.message }}
      </div>
    </div>
  </div>
</template>

<script>
import * as types from 'store/modules/warningmsg/mutation-types'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'warningmsg',
  data () {
    return {
      app: this.$parent.$parent.$parent.$parent,
      showall: false
    }
  },
  props: [ 'pcDisp' ],
  created () {
    this.receivedWarningmsg()
  },
  computed: {
    ...mapGetters({
      warningmsg: types.GET_WARNINGMSG
    })
  },
  methods: {
    warningmsgDisp (warningmsgRows) {
      return warningmsgRows.length > 0
    },
    toggle () {
      this.showall = !this.showall
    },
    ...mapActions({
      receivedWarningmsg: types.RECEIVED_WARNINGMSG
    })
  }
}
</script>

<style src="./style.scss" lang='scss'></style>


// WEBPACK FOOTER //
// component.vue?6e3cb488